import { RootState } from '@reducers';

export const selectClaim = (state: RootState) => state.userDashboardRouteReducer.claimReducer;
